module.exports = __webpack_public_path__ + "img/login.08073ebf.webp";